"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var identifiers_1 = require("../identifiers");
var react_css_themr_1 = require("@vidazoo/react-css-themr");
var TableHeaderColumn_1 = require("./TableHeaderColumn");
var theme = require("./theme.scss");
var ThemedTableHeaderColumn = react_css_themr_1.themr(identifiers_1.TABLE_HEADER_COLUMN, theme)(TableHeaderColumn_1.default);
exports.TableHeaderColumn = ThemedTableHeaderColumn;
exports.default = ThemedTableHeaderColumn;
